import React, {Fragment, useEffect, useState} from 'react'
import ym from 'react-yandex-metrika'
import { translate } from 'react-i18next'
import { Helmet } from 'react-helmet'
import './style.css'

const Service = ({ t }) => {

    const [currentState, setCurrentState] = useState("website")

    useEffect(() => {
        prepareClasses()
        ym('hit', '/service')
        return () => {
            prepareClasses(false)
        }
    }, [])

    const prepareClasses = (flag = true) => {
        document.body.classList.toggle('blue')
        const logo = document.getElementsByClassName('app__nav--logo')[0].childNodes[0]
        const links = document.getElementsByClassName('app__nav--links')[0].childNodes
        logo.classList.toggle('yellow')
        for (let link of links)
            if (!flag)
                link.classList.remove('smoke')
            else
                link.classList.add('smoke')
    }

    const Content = () => {
        switch (currentState) {
            case "website":
                return (
                    <Fragment>
                        <h1>Разрабатываем современные сайты, которые решают реальные задачи вашего бизнеса</h1>
                        <p>Сделаем сайт под ключ, позаботившись обо всех этапах – от постановки желаемых целей и
                            маркетинговой задачи до программирования, дизайна и описания ваших услуг.</p>
                        <p>К разработке сайтов наша команда подходит очень ответственно: именно этот digital-продукт
                            будет лицом вашего бизнеса в интернете и важной точкой касания с клиентом. Мы хотим, чтобы
                            он точно попадал в целевую аудиторию и в итоге приносил бизнесу доход.</p>
                        <p>Разрабатывая сайт, мы всегда готовы подстроиться под ваш темп работы: от составления
                            технического задания и брифов до личной встречи и согласования всех нюансов проекта. Главная
                            цель нашей работы – добиться результата, который позволит привлечь, удержать и побудить
                            клиента выбрать именно вашу компанию.</p>
                        <p>Мы работаем с технологиями:</p>
                        <ul>
                            <li>Wordpress;</li>
                            <li>Bitrix;</li>
                            <li>PostgreSQL, Mongodb;</li>
                            <li>GO, NodeJS, Python, PHP.</li>
                        </ul>
                        <p><strong>Мы разрабатываем сайты, которые помогают бизнесу:</strong></p>
                        <ul>
                            <li>автоматизировать бизнес-процессы;</li>
                            <li>увеличить производительность;</li>
                            <li>легко масштабироваться;</li>
                            <li>решать нетривиальные задачи;</li>
                            <li>улучшить имидж компании.</li>
                        </ul>
                        <p><strong>У нас высокая компетенция в работе со сферами:</strong></p>
                        <ul>
                            <li>гостинично-ресторанного бизнеса (HоReCa);</li>
                            <li>медицины;</li>
                            <li>производства;</li>
                            <li>электронной коммерции (e-commerce);</li>
                            <li>интернет-бронирования отелей (booking).</li>
                        </ul>
                    </Fragment>
                )
            case "mobile":
                return (
                    <Fragment>
                        <h1>Нативные мобильные приложения для iOS и Android</h1>
                        <p>Мы разрабатываем мобильные приложения, которые оптимизированы для каждой платформы: Java и
                            Kotlin для Android, Swift и Objective-C для iOS.</p>
                        <p>Используя нативную разработку, мы конструируем наши приложения органичными для каждой
                            системы. У нас нет ограничений в возможностях и функциях: в работе мы можем использовать все
                            аппаратные опции смартфона (уведомления, геолокацию, работу с камерой, bluetooth и
                            прочие).</p>
                        <p>Обладая большим опытом разработки, мы можем создать приложение для вашего продукта, с учетом
                            решения проблемных мест в уже работающем бизнес-процессе. Тем самым мы выстроим комфортную и
                            продуманную коммуникацию бизнеса с конечным потребителем.</p>
                        <p>Помимо стабильной работы мобильного приложения, важным этапом разработки является серверная
                            часть проекта. Мы используем микросервисную архитектуру для высокой отказоустойчивости,
                            более простой масштабируемости, легкого обслуживания и адаптируемости к росту трафика.</p>
                        <p>Мы работаем с технологиями:</p>
                        <ul>
                            <li>Swift, Objective-C, Kotlin, Java;</li>
                            <li>UIKit, SwiftUI.</li>
                        </ul>
                        <p><strong>Наши приложения помогут клиенту и вашему бизнесу:</strong></p>
                        <ul>
                            <li>зарегистрировать пользователя в программе лояльности;</li>
                            <li>сформировать и отправить заказ;</li>
                            <li>управлять «умной» техникой и прописывать свои алгоритмы под конкретные задачи;</li>
                            <li>улучшить имидж компании;</li>
                            <li>автоматизировать необходимые процессы;</li>
                            <li>получить обратную связь;</li>
                            <li>оценить ваш сервис.</li>
                        </ul>
                    </Fragment>
                )
            case "design":
                return (
                    <Fragment>
                        <h1>Дизайн и брендинг как неотъемлемая часть коммуникации с клиентом</h1>
                        <p>Создание визуального образа проекта, который решает задачи бизнеса – это всегда кропотливая работа. Правильно построенный User Experience (пользовательский опыт) – ключевой фактор в достижении успеха.</p>
                        <p>Дизайн и брендинг способны улучшить позицию вашего бизнеса среди конкурентов и вывести взаимодействие потребителя с продуктом на качественно новый уровень. Это касается всех визуальных продуктов бизнеса: начиная с сайта и заканчивая визиткой или рекламным буклетом.</p>
                        <p>Разрабатывая наши дизайн-системы, мы учитываем множество факторов: целевую аудиторию, запрос бизнеса, анализ метрик, удачный и неудачный опыт конкурентов. Это необходимо, чтобы минимизировать отказы и увеличить конверсию если это digital-продукт, увеличить узнаваемость бренда и привлечь новую аудиторию, если это offline-продукт.</p>
                        <p>Мы работаем с графическими редакторами:</p>
                        <ul>
                            <li>Sketch;</li>
                            <li>Figma;</li>
                            <li>Illustrator;</li>
                            <li>Adobe After Effect;</li>
                        </ul>
                        <p><strong>У нас высокая компетенция в работе со сферами:</strong></p>
                        <ul>
                            <li>гостинично-ресторанного бизнеса (HоReCa);</li>
                            <li>медицины;</li>
                            <li>производства;</li>
                            <li>электронной коммерции (e-commerce);</li>
                            <li>интернет-бронирования отелей (booking).</li>
                        </ul>
                    </Fragment>
                )
            default:
                return (<Fragment/>)
        }
    }

    return (
        <main className="app__content--service">
            <Helmet>
                <title>{t('Service')}</title>
            </Helmet>
            <div className="app__content--description">
                <Content/>
            </div>
            <div className="app__content--categories">
                <div className="app__content--category">
                        <span className="app__content--category-name" onClick={(e) => setCurrentState("website")}>
                            {t('service.website.name')}
                        </span>
                    <ul className="app__content--subcategory">
                        <li className="app__content--subcategory-name">
                            {t('service.website.items.landingPage')}
                        </li>
                        <li className="app__content--subcategory-name">
                            {t('service.website.items.corporateWebsite')}
                        </li>
                        <li className="app__content--subcategory-name">
                            {t('service.website.items.eCommerce')}
                        </li>
                    </ul>
                </div>
                <div className="app__content--category">
            <span
                className="app__content--category-name"
                onClick={(e) => setCurrentState("mobile")}
                dangerouslySetInnerHTML={{__html: t('service.mobile.name')}}/>
                    <ul className="app__content--subcategory">
                        <li className="app__content--subcategory-name">{t('service.mobile.items.social')}</li>
                        <li className="app__content--subcategory-name">{t('service.mobile.items.eCommerce')}</li>
                        <li className="app__content--subcategory-name">{t('service.mobile.items.enterprise')}</li>
                    </ul>
                </div>
                <div className="app__content--category">
                    <span className="app__content--category-name" onClick={(e) => setCurrentState("design")}>
                        {t('service.branding.name')}
                    </span>
                    <ul className="app__content--subcategory">
                        <li className="app__content--subcategory-name">{ t('service.branding.items.design') }</li>
                        <li className="app__content--subcategory-name">{ t('service.branding.items.ui') }</li>
                        <li className="app__content--subcategory-name">{ t('service.branding.items.id') }</li>
                    </ul>
                </div>
                <div className="app__content--category">
                    <span className="app__content--category-name">
                        { t('service.ads.name') }
                    </span>
                    <ul className="app__content--subcategory">
                        <li className="app__content--subcategory-name">{ t('service.ads.items.seo') }</li>
                        <li className="app__content--subcategory-name">{ t('service.ads.items.smm') }</li>
                        <li className="app__content--subcategory-name">{ t('service.ads.items.context') }</li>
                    </ul>
                </div>
            </div>
        </main>
    )

}

export default translate('translations')(Service)



// WEBPACK FOOTER //
// ./src/Pages/Service/index.js